const API_URL = import.meta.env.VITE_API_URL || '/api';

export interface Product {
  name: string;
  count: number;
}

export interface WaitlistEntry {
  email: string;
  source: string | null;
  utmSource: string | null;
  utmCampaign: string | null;
  date: string;
}

export interface WaitlistData {
  product: string;
  count: number;
  entries: WaitlistEntry[];
}

export interface DeleteResponse {
  success: boolean;
  message?: string;
}

export async function fetchProducts(): Promise<Product[]> {
  const res = await fetch(`${API_URL}/waitlist`);
  if (!res.ok) throw new Error('Failed to fetch products');
  const data = await res.json();
  return data.products || [];
}

export async function fetchWaitlist(product: string): Promise<WaitlistData> {
  const res = await fetch(`${API_URL}/waitlist/${encodeURIComponent(product)}/admin`);
  if (!res.ok) throw new Error('Failed to fetch waitlist');
  return res.json();
}

export async function deleteWaitlistEntry(product: string, email: string): Promise<DeleteResponse> {
  const res = await fetch(`${API_URL}/waitlist/${encodeURIComponent(product)}/${encodeURIComponent(email)}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error('Failed to delete entry');
  return res.json();
}
